import { FormSurveyAnswer } from '../../../models/forms';
import {
    AttendeeSurvey,
    BUYER_ID,
    isAddressQuestion,
    SurveyFormData,
    SurveyQuestion,
} from '../../../models/survey';
import {
    isAttendeeField,
    transformAddressForApi,
} from '../../../utils/surveys';
import { getCleanedFormDataFactory } from './getCleanedFormDataFactory';

export const getAnswersPayloadForBackendFactory = ({
    attendeeSurveys,
    questionsForBuyer,
}: {
    attendeeSurveys: Array<AttendeeSurvey>;
    questionsForBuyer: Array<SurveyQuestion>;
}) => {
    const getCleanedFormData = getCleanedFormDataFactory({
        attendeeSurveys,
        questionsForBuyer,
    });

    return (formData: SurveyFormData) => {
        const cleanedFormData = getCleanedFormData(formData);

        return Object.entries(cleanedFormData).flatMap(
            ([
                formSectionNameOrRootFieldName,
                sectionFieldsWithAnswersOrRootFieldAnswer,
            ]) => {
                const attendeeId = isAttendeeField(
                    formSectionNameOrRootFieldName,
                )
                    ? formSectionNameOrRootFieldName
                    : null;

                if (
                    !attendeeId &&
                    formSectionNameOrRootFieldName !== BUYER_ID
                ) {
                    return [];
                }

                return Object.entries(
                    sectionFieldsWithAnswersOrRootFieldAnswer,
                ).map<FormSurveyAnswer>(([questionId, questionAnswer]) => ({
                    attendee_id: attendeeId,
                    question_id: questionId,
                    answer: isAddressQuestion(questionId)
                        ? transformAddressForApi(
                              questionAnswer as Parameters<
                                  typeof transformAddressForApi
                              >[0],
                          )
                        : (questionAnswer as FormSurveyAnswer['answer']),
                }));
            },
        );
    };
};
